import React from 'react';

// Hexagon "H" mark, rebuilt as scalable SVG. Works on light or dark backgrounds.
export const LogoMark = ({ size = 36, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role="img"
    aria-label="HolidayHive"
  >
    <defs>
      <linearGradient id="hhHexGrad" x1="12" y1="6" x2="90" y2="94" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#FDBA4D" />
        <stop offset="1" stopColor="#F26A1B" />
      </linearGradient>
    </defs>
    {/* Hexagon body (flat top/bottom) with softly rounded corners */}
    <polygon
      points="97,50 73.5,90.7 26.5,90.7 3,50 26.5,9.3 73.5,9.3"
      fill="url(#hhHexGrad)"
      stroke="url(#hhHexGrad)"
      strokeWidth="6"
      strokeLinejoin="round"
    />
    {/* subtle top facet highlight */}
    <polygon points="26.5,9.3 73.5,9.3 50,50" fill="#ffffff" opacity="0.08" />
    {/* H uprights */}
    <rect x="30" y="27" width="11" height="46" rx="5" fill="#ffffff" />
    <rect x="59" y="27" width="11" height="46" rx="5" fill="#ffffff" />
    {/* central isometric cube (the H crossbar node) */}
    <polygon points="50,40 59,45.5 50,51 41,45.5" fill="#FFD39B" />
    <polygon points="41,45.5 50,51 50,62 41,56.5" fill="#F5821F" />
    <polygon points="59,45.5 50,51 50,62 59,56.5" fill="#C85A15" />
  </svg>
);

// Full lockup: mark + "HolidayHive" wordmark (+ optional tagline).
// Wordmark uses theme colours so it adapts to light/dark mode.
const Logo = ({ size = 32, showTagline = false, className = '' }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <LogoMark size={size} />
    <span className="inline-flex flex-col leading-none">
      <span className="font-heading font-extrabold tracking-tight" style={{ fontSize: size * 0.6 }}>
        <span className="text-[#0f2144] dark:text-white">Holiday</span>
        <span className="text-[#F5821F]">Hive</span>
      </span>
      {showTagline && (
        <span className="flex items-center gap-1.5 mt-1.5">
          <span className="h-px w-4 bg-[#F5821F]" />
          <span
            className="font-semibold tracking-[0.18em] text-[#0f2144]/80 dark:text-white/70 whitespace-nowrap"
            style={{ fontSize: Math.max(7, size * 0.17) }}
          >
            LEAVE MANAGEMENT MADE SIMPLE
          </span>
          <span className="h-px w-4 bg-[#F5821F]" />
        </span>
      )}
    </span>
  </span>
);

export default Logo;
